<template>
    <v-card>
        <!-- <img src='https://avataaars.io/?avatarStyle=Circle&topType=ShortHairShortRound&accessoriesType=Blank&hairColor=BrownDark&facialHairType=BeardMedium&facialHairColor=Black&clotheType=Hoodie&clotheColor=Heather&eyeType=Happy&eyebrowType=Default&mouthType=Serious&skinColor=Light'
/>
        <img src='https://avataaars.io/?avatarStyle=Circle&topType=ShortHairShortWaved&accessoriesType=Blank&hairColor=BlondeGolden&facialHairType=Blank&clotheType=ShirtCrewNeck&clotheColor=Red&eyeType=Happy&eyebrowType=Default&mouthType=Default&skinColor=Pale'
/> -->
        <v-card-title class="headline font-weight-regular blue-grey white--text">
            Meal Planner
        </v-card-title>
        <v-card class="pa-5 text-md-center" text-center v-if="loading">
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
        </v-card>
        <v-tabs v-model="active">
            <v-tab
                v-for="plan in orderedPlan"
                v-bind:key="plan.day"
            >
                {{ plan.name }}
            </v-tab>
            <v-tab-item 
                v-for="plan in orderedPlan" 
                v-bind:key="plan.day"
            >
                <v-container>
                    <v-layout wrap>
                        <v-flex xs12 md6 pa-2>
                            <v-text-field 
                                label="Name"
                                v-model="plan.name"
                                :disabled="true"
                                box
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 pa-2>
                            <v-text-field 
                                label="Week Number"
                                v-model="plan.week"
                                :disabled="true"
                                box
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-card-text>
                        <v-layout align-center row pb-4>
                            <v-flex xs4 sm2 md1>
                                <v-avatar slot="activator" size="50px">
                                    <img
                                        src="https://avataaars.io/?avatarStyle=Circle&topType=ShortHairShortRound&accessoriesType=Blank&hairColor=BrownDark&facialHairType=BeardMedium&facialHairColor=Black&clotheType=Hoodie&clotheColor=Heather&eyeType=Happy&eyebrowType=Default&mouthType=Serious&skinColor=Light"
                                        alt="Avatar"
                                    >
                                </v-avatar>
                            </v-flex>
                            <v-flex sm10 md11>
                                <span class="title">Meals for Aaron</span>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.aaron.morningStack.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.aaron.morningStack"
                                    :items="meals"
                                    :label="'Morning Stack'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="stackFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.aaron.morningStack = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.aaron.breakfast.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.aaron.breakfast"
                                    :items="meals"
                                    :label="'Breakfast'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="breakfastFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.aaron.breakfast = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        
                        <v-layout wrap>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.aaron.morningSnack.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.aaron.morningSnack"
                                    :items="meals"
                                    :label="'Morning Snack'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="snackFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.aaron.morningSnack = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.aaron.afternoonStack.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.aaron.afternoonStack"
                                    :items="meals"
                                    :label="'Afternoon Stack'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="stackFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.aaron.afternoonStack = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>

                        <v-layout wrap>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.aaron.lunch.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.aaron.lunch"
                                    :items="meals"
                                    :label="'Lunch'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="lunchFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.aaron.lunch = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.aaron.afternoonSnack.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.aaron.afternoonSnack"
                                    :items="meals"
                                    :label="'Afternoon Snack'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="snackFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.aaron.afternoonSnack = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>

                        <v-layout wrap>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.aaron.eveningStack.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.aaron.eveningStack"
                                    :items="meals"
                                    :label="'Evening Stack'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="stackFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.aaron.eveningStack = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.aaron.dinner.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.aaron.dinner"
                                    :items="meals"
                                    :label="'Dinner'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="dinnerFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.aaron.dinner = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>

                        <v-layout wrap>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.aaron.eveningSnack.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.aaron.eveningSnack"
                                    :items="meals"
                                    :label="'Evening Snack'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="snackFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.aaron.eveningSnack = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        
                        <v-divider class="pb-4"></v-divider>

                        <v-layout align-center row pb-4>
                            <v-flex xs4 sm2 md1>
                                <v-avatar slot="activator" size="50px">
                                    <img
                                        src="https://avataaars.io/?avatarStyle=Circle&topType=ShortHairShortWaved&accessoriesType=Blank&hairColor=BlondeGolden&facialHairType=Blank&clotheType=ShirtCrewNeck&clotheColor=Red&eyeType=Happy&eyebrowType=Default&mouthType=Serious&skinColor=Pale"
                                        alt="Avatar"
                                    >
                                </v-avatar>
                            </v-flex>
                            <v-flex sm10 md11>
                                <span class="title">Meals for Ronan</span>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.ronan.morningStack.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.ronan.morningStack"
                                    :items="meals"
                                    :label="'Morning Stack'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="stackFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.ronan.morningStack = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.ronan.breakfast.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.ronan.breakfast"
                                    :items="meals"
                                    :label="'Breakfast'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="breakfastFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.ronan.breakfast = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                        
                        <v-layout wrap>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.ronan.morningSnack.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.ronan.morningSnack"
                                    :items="meals"
                                    :label="'Morning Snack'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="snackFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.ronan.morningSnack = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.ronan.afternoonStack.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.ronan.afternoonStack"
                                    :items="meals"
                                    :label="'Afternoon Stack'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="stackFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.ronan.afternoonStack = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>

                        <v-layout wrap>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.ronan.lunch.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.ronan.lunch"
                                    :items="meals"
                                    :label="'Lunch'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="lunchFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.ronan.lunch = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.ronan.afternoonSnack.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.ronan.afternoonSnack"
                                    :items="meals"
                                    :label="'Afternoon Snack'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="snackFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.ronan.afternoonSnack = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>

                        <v-layout wrap>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.ronan.eveningStack.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.ronan.eveningStack"
                                    :items="meals"
                                    :label="'Evening Stack'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="stackFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.ronan.eveningStack = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.ronan.dinner.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.ronan.dinner"
                                    :items="meals"
                                    :label="'Dinner'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="dinnerFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.ronan.dinner = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>

                        <v-layout wrap>
                            <v-flex md1 pa-2>
                                <v-text-field
                                    v-model="plan.ronan.eveningSnack.portion"
                                    hint="portion"
                                    solo
                                ></v-text-field>
                            </v-flex>
                            <v-flex md4 pa-2>
                                <v-autocomplete
                                    v-model="plan.ronan.eveningSnack"
                                    :items="meals"
                                    :label="'Evening Snack'"
                                    persistent-hint
                                    :return-object=true
                                    item-text="name"
                                    :filter="snackFilter"
                                ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 pa-2>
                                <v-btn flat icon color="primary"
                                    @click="plan.ronan.eveningSnack = {portion:1}"
                                >
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-container>
            </v-tab-item>
        </v-tabs>
        <v-container v-if="!loading">
            <v-btn block color="primary" @click="savePlan" :disabled="saving">Save Plan</v-btn>
            <v-progress-linear v-if="saving" v-model="progress"></v-progress-linear>
        </v-container>
        <v-snackbar v-model="snackbar">
            Plan Updated Successfully.
        </v-snackbar>
    </v-card>
</template>

<script>
import db from '@/firebase/firestore'
import _ from 'lodash'
export default {
    name: 'Plan',
    data() {
        return {
            plan: [],
            meals: [],
            items: [],
            selected: null,
            active: null,
            model: null,
            loading: true,
            saving: false,
            progress: 0,
            snackbar: false
        }
    },
    created() {
        // Load Meals
        let mealRef = db.collection('meals')
        mealRef.get().then((snapshot) => {
            this.loading = false
            snapshot.forEach( doc => {
                let meal = doc.data()
                this.meals.push({
                    id: doc.id,
                    name: meal.name,
                    type: meal.type,
                    calories: Math.round(meal.totalCalories),
                    fat: Math.round(meal.totalFat),
                    carbohydrates: Math.round(meal.totalCarbohydrates),
                    protein: Math.round(meal.totalProtein),
                    cost: Math.round(meal.totalCost*100)/100
                })
            })
        })
        // Load Plan
        let planRef = db.collection('plan')
        planRef.get().then((snapshot) => {
            snapshot.forEach( doc => {
                let data = doc.data()
                // if( data.aaron.morningStack == null ) data.aaron.morningStack = {}
                // if( data.aaron.breakfast == null ) data.aaron.breakfast = {}
                // if( data.aaron.morningSnack == null ) data.aaron.morningSnack = {}
                // if( data.aaron.afternoonStack == null ) data.aaron.afternoonStack = {}
                // if( data.aaron.lunch == null ) data.aaron.lunch = {}
                // if( data.aaron.afternoonSnack == null ) data.aaron.afternoonSnack = {}
                // if( data.aaron.eveningStack == null ) data.aaron.eveningStack = {}
                // if( data.aaron.dinner == null ) data.aaron.dinner = {}
                // if( data.aaron.eveningSnack == null ) data.aaron.eveningSnack = {}
                // if( data.ronan.morningStack == null ) data.ronan.morningStack = {}
                // if( data.ronan.breakfast == null ) data.ronan.breakfast = {}
                // if( data.ronan.morningSnack == null ) data.ronan.morningSnack = {}
                // if( data.ronan.afternoonStack == null ) data.ronan.afternoonStack = {}
                // if( data.ronan.lunch == null ) data.ronan.lunch = {}
                // if( data.ronan.afternoonSnack == null ) data.ronan.afternoonSnack = {}
                // if( data.ronan.eveningStack == null ) data.ronan.eveningStack = {}
                // if( data.ronan.dinner == null ) data.ronan.dinner = {}
                // if( data.ronan.eveningSnack == null ) data.ronan.eveningSnack = {}
                this.plan.push(data)
            })
            this.loading = false
        })
    },
    computed: {
        orderedPlan: function() {
            return _.orderBy(this.plan,'day')
        }
    },
    methods: {
        clearMeal( meal, name ) {
            console.log('clear', this.plan)
            this.plan[0].aaron.morningStack = {
                portion: 1
            }
        },
        savePlan() {
            this.progress = 0
            this.saving = true
            this.plan.forEach( day => {
                db.collection('plan').doc(day.day.toString()).set(day).then(() => {
                    this.progress = Math.round(day.day/14) * 100
                    if(day.day == 14 ) {
                        this.saving = false
                        this.snackbar = true
                    }
                }).catch((err) => {
                    this.progress = 0
                })
            })
        },
        breakfastFilter(item, queryText, itemText) {
            if( item.type == 'Breakfast' ) return true
        },
        lunchFilter(item, queryText, itemText) {
            if( item.type == 'Lunch' ) return true
        },
        dinnerFilter(item, queryText, itemText) {
            if( item.type == 'Dinner' ) return true
        },
        snackFilter(item, queryText, itemText) {
            if( item.type == 'Snack' ) return true
        },
        stackFilter(item, queryText, itemText) {
            if( item.type == 'Stack' ) return true
        }

    }
}
</script>
